import { TrainingView, type TrainingAnswerGiven } from '@myrewards/contracts';
import { queryOptions } from '@tanstack/react-query';
import { request } from './client';

export const trainingKeys = { all: ['training'] as const };

/** The training as this person sees it (TRN1, APP-076): lessons, practice pages, check, progress. */
export const trainingQuery = queryOptions({
  queryKey: trainingKeys.all,
  queryFn: ({ signal }) => request('/api/v1/training', { schema: TrainingView, signal }),
  staleTime: 30_000,
});

const post = (path: string, body: object): Promise<TrainingView> =>
  request(`/api/v1/training${path}`, { method: 'POST', body, schema: TrainingView });

/** A lesson's walkthrough step finished. */
export function finishLesson(lesson: string): Promise<TrainingView> {
  return post('/lessons', { lesson });
}

/** One answer to the knowledge check; the server says whether it's right. */
export function answerQuestion(answer: TrainingAnswerGiven): Promise<TrainingView> {
  return post('/answers', answer);
}

/** Finishes the training: all three right. Takes it off Waiting on you. */
export function completeTraining(): Promise<TrainingView> {
  return post('/complete', {});
}

/** Starts over: lessons and answers cleared, and the training back on Waiting on you. */
export function resetTraining(): Promise<TrainingView> {
  return post('/reset', {});
}
